export default "__VITE_ASSET__CcuaFUw8__"